export const checkboxNames = {
  TP_DATA_INPUT: "tpDataInput",
  TP_MANAGER_REVIEW: "tpManagerReview",
  TP_ARCHIVE_VIEW: "tpArchiveView",
  TP_ARCHIVE_EDIT: "tpArchiveEdit",
  TU_EDIT: "tuEdit",
  TU_REVIEW: "tuReview",
  IM_EDIT: "imEdit",
  IM_VIEW: "imView",
  LM_EDIT: "lmEdit",
  LM_VIEW: "lmView",
  PA_EDIT: "paEdit",
  PA_VIEW: "paView",
};

export const TicketUploadPermissions = [
  {
    label: "Edit",
    name: "tuEdit",
  },
  {
    label: "Review",
    name: "tuReview",
  },
];

export const TicketProcessingPermissions = [
  {
    label: "Data Input",
    name: "tpDataInput",
  },
  {
    label: "Manager Review",
    name: "tpManagerReview",
  },
  {
    label: "Archive View",
    name: "tpArchiveView",
  },
  {
    label: "Archive Edit",
    name: "tpArchiveEdit",
  },
];

export const InvoiceManagementPermissions = [
  {
    label: "Edit",
    name: "imEdit",
  },
  {
    label: "View",
    name: "imView",
  },
];

export const LienManagementPermissions = [
  {
    label: "Edit",
    name: "lmEdit",
  },
  {
    label: "View",
    name: "lmView",
  },
];

export const ProjectAnalysisPermissions = [
  {
    label: "Edit",
    name: "paEdit",
  },
  {
    label: "View",
    name: "paView",
  },
];

export const FinanceSectionSublist = [
  {
    key: "tu",
    label: "Ticket Upload",
    options: TicketUploadPermissions,
  },
  {
    key: "tp",
    label: "Ticket Processing",
    options: TicketProcessingPermissions,
  },
  {
    key: "im",
    label: "Invoice Management",
    options: InvoiceManagementPermissions,
  },
  {
    key: "lm",
    label: "Lien Process",
    options: LienManagementPermissions,
  },
  {
    key: "pa",
    label: "Project Analysis",
    options: ProjectAnalysisPermissions,
  },
];

const FinanceNameList = [
  "tuReview",
  "tuEdit",
  "tpDataInput",
  "tpManagerReview",
  "tpArchiveView",
  "tpArchiveEdit",
  "imEdit",
  "imView",
  "lmEdit",
  "lmView",
  "paEdit",
  "paView",
];

export const getActiveKeys = (values) => {
  const activeKeys = Object.entries(values).reduce((keyList, [key, value]) => {
    if (FinanceNameList.includes(key)) {
      if (value) {
        if (key.includes("tu")) {
          keyList.push("tu");
        } else if (key.includes("tp")) {
          keyList.push("tp");
        } else if (key.includes("im")) {
          keyList.push("im");
        } else if (key.includes("lm")) {
          keyList.push("lm");
        } else if (key.includes("pa")) {
          keyList.push("pa");
        }
      }
    }
    return keyList;
  }, []);
  return activeKeys;
};
